import React from "react";
import "./WhyUs.css";

const items = [
  {
    color: "#2ecc71",
    title: "We don't charge by your size",
    text:
      "All our services have set prices and aren’t variable based on your business size.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM4 20a8 8 0 0 1 16 0" />
      </svg>
    ),
  },
  {
    color: "#2F80ED",
    title: "Revolutionary, simplified process",
    text:
      "No fishing for info or proposals. Pick your solution, checkout, and relax.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 6h12M4 12h10M4 18h6M18 5l3 3-6 6h-3v-3l6-6z" />
      </svg>
    ),
  },
  {
    color: "#BB6BD9",
    title: "Happy, non-salesy support team",
    text:
      "No sales reps here — just a friendly support team that’s a call away.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="8" cy="9" r="1.8" />
        <circle cx="16" cy="9" r="1.8" />
        <path d="M7 15c2.5 2 7.5 2 10 0" />
        <path d="M12 2a10 10 0 1 1 0 20A10 10 0 0 1 12 2Z" opacity=".15" />
      </svg>
    ),
  },
];

function WhyUs() {

    const brush = `${process.env.PUBLIC_URL}/brush-stroke.svg`; 
    return (
        <section className="whyus" style={{ "--brush": `url(${brush})` }}>
        <div className="whyus__inner">
            <header className="whyus__head">
            <h2 className="whyus__title">So, why us?</h2>
            <span className="whyus__underline" />
            <a className="whyus__cta" href="#contact">Learn More!</a>
            </header>

            <div className="whyus__grid" role="list">
            {items.map((it) => (
                <article className="whyusCard" role="listitem" key={it.title}>
                <div className="whyusCard__icon" style={{ "--i": it.color }}>
                    {it.icon}
                </div>
                <h3 className="whyusCard__title">{it.title}</h3>
                <p className="whyusCard__text">{it.text}</p>
                </article>
            ))}
            </div>
        </div>
        </section>
    );
}

export default WhyUs;
